import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMap3D } from '@obvious.tech/constellation'

export const Map3D = defineEntity('Map3D', {
  endpoint: 'cartography/api/Map3D',
  schema: SNoop<IMap3D>(),
})
